import Layout from '../../views/interestRate/pawIntrestRate/Index'
import List from '../../views/interestRate/pawIntrestRate/List'
import Edit from '../../views/interestRate/pawIntrestRate/Edit'
import Create from '../../views/interestRate/pawIntrestRate/Create'
import Show from '../../views/interestRate/pawIntrestRate/Show'
import Permissions from '@/permissions'

export const pawnInterestRateRouters = {
  path: 'pawn-interest-rate',
  component: Layout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.interestRate.pawn.manage],
    groups: 'pawn-interest-rate'
  },
  children: [
    {
      path: '',
      name: 'list-pawn-interest-rate',
      component: List,
      meta: {
        permissions: [Permissions.backend.interestRate.pawn.list],
        groups: 'pawn-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Pawn Interest Rate',
            name_km: 'អត្រាការប្រាក់បញ្ចាំ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'create',
      name: 'create-pawn-interest-rate',
      component: Create,
      meta: {
        permissions: [Permissions.backend.interestRate.pawn.store],
        groups: 'pawn-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Pawn Interest Rate',
            name_km: 'អត្រាការប្រាក់បញ្ចាំ'
          },
          {
            name_en: 'Create',
            name_km: 'បង្កើត'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'edit-pawn-interest-rate',
      component: Edit,
      meta: {
        permissions: [Permissions.backend.interestRate.pawn.edit],
        groups: 'pawn-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Pawn Interest Rate',
            name_km: 'អត្រាការប្រាក់បញ្ចាំ'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'show-pawn-interest-rate',
      component: Show,
      meta: {
        permissions: [Permissions.backend.interestRate.pawn.show],
        groups: 'pawn-interest-rate',
        breadcrumb: [
          {
            name_en: 'Interest Rate',
            name_km: 'អត្រាការប្រាក់'
          },
          {
            name_en: 'Pawn Interest Rate',
            name_km: 'អត្រាការប្រាក់បញ្ចាំ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
